import { Star } from "lucide-react";

interface Props {
  value: number;
  onChange?: (value: number) => void;
  readonly?: boolean;
  size?: number;
}

const StarRating = ({ value, onChange, readonly = false, size = 28 }: Props) => {
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => onChange?.(star)}
          className={`
            transition-all duration-300
            ${readonly ? "cursor-default" : "hover:scale-125 active:scale-95"}
          `}>
          <Star size={size} strokeWidth={2} className={star <= value ? "fill-yellow-400 text-yellow-400" : "text-gray-300"} />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
